import React from 'react';
import { observer } from '../../../shared/observer';
import { router } from '../../../shared/hashRouter';
import { runBusy, isBusy } from '../../../shared/busy';
import { CheckoutSteps } from './CheckoutSteps';

// Шаг чекаута «Подписание акта аренды тары».
// Содержимое повторяет публичную страницу app/views/rent_acts/show.html.slim:
// реквизиты юрлица, количество тары, маскированный телефон, дата и условия.
//
// Режим подписи выбирает СЕРВЕР и сообщает флагом rent_act.code_required:
// одной кнопкой (номер подтверждён при входе) либо 4 цифры из SMS.
class TareSignFormView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { busy: {}, loading: true, error: null, notice: null, code: '' };
  }

  componentDidMount() {
    const order = this.props.order;
    // Прямой вход по ссылке/F5: стор живёт в памяти, заказа нет — возвращаем
    // клиента в начало чекаута (тот же приём, что в PaymentForm)
    if (!order.order || !order.order.id) {
      router.go('#checkout');
      return;
    }

    order.prepareRentAct()
      .then((res) => {
        if (!res || res.status === 'not_required' || res.status === 'signed') {
          router.go('#payment');
          return;
        }
        this.setState({ loading: false });
      })
      .catch((err) => this.setState({ loading: false, error: err.message || 'Не удалось загрузить акт' }));
  }

  setCode = (e) => {
    const v = (e.target.value || '').replace(/\D/g, '').slice(0, 4);
    this.setState({ code: v });
  };

  sign = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    this.setState({ error: null, notice: null });

    runBusy(this, 'sign', async () => {
      const res = await this.props.order.signRentAct(this.state.code);
      if (!res) return;

      if (res.status === 'signed') {
        router.go('#payment');
        return;
      }
      if (res.status === 'not_required') {
        router.go('#payment');
        return;
      }
      // wrong_code / too_many_attempts / code_required / stale — остаёмся
      // на экране и показываем сообщение сервера
      this.setState({ error: res.message || 'Не удалось подписать акт', code: '' });
    }).catch((err) => this.setState({ error: err.message || 'Не удалось подписать акт' }));
  };

  resend = () => {
    this.setState({ error: null, notice: null });
    runBusy(this, 'resend', async () => {
      const res = await this.props.order.resendRentActCode();
      if (!res) return;
      if (res.status === 'sent') {
        this.setState({ notice: 'Новый код отправлен на ' + (res.masked_phone || 'ваш номер') });
      } else if (res.status === 'throttled') {
        this.setState({ error: 'Новый код можно запросить через ' + res.retry_after + ' с' });
      }
    }).catch((err) => this.setState({ error: err.message || 'Не удалось отправить код' }));
  };

  skip = () => {
    this.setState({ error: null, notice: null });
    runBusy(this, 'skip', async () => {
      const res = await this.props.order.skipRentAct();
      if (res && res.status === 'skipped') router.go('#payment');
      else this.setState({ error: (res && res.message) || 'Подписание обязательно' });
    }).catch((err) => this.setState({ error: err.message || 'Не удалось пропустить шаг' }));
  };

  renderRequisites(rek) {
    const parts = [];
    if (rek.ur_inn) parts.push('ИНН ' + rek.ur_inn);
    if (rek.ur_ogrn_ip) parts.push('ОГРН/ОГРНИП ' + rek.ur_ogrn_ip);
    if (rek.ur_address) parts.push(rek.ur_address);
    if (rek.ur_phone) parts.push(rek.ur_phone);
    if (!parts.length) return null;
    return <div className="ng-tare-sign__rek">{parts.join(' · ')}</div>;
  }

  render() {
    if (this.state.loading) {
      return <div className="ng-cart"><p>Загрузка акта…</p></div>;
    }

    const act = this.props.order.rentAct;
    if (!act) {
      return (
        <div className="ng-cart">
          <div className="order-message">{this.state.error || 'Акт недоступен'}</div>
        </div>
      );
    }

    const rek = act.org_requisites || {};
    const codeRequired = !!act.code_required;
    const noAttempts = codeRequired && act.attempts_left === 0;

    return (
      <form className="ng-checkout ng-tare-sign" onSubmit={this.sign}>
        <div className="ng-checkout__nav">
          <a href="#" onClick={(e) => { e.preventDefault(); router.go('#checkout'); }}>← Назад к доставке</a>
        </div>

        <h1>Подписание акта</h1>
        <CheckoutSteps active={2} hasSign={true} />

        <section className="ng-checkout__section ng-tare-sign__card">
          {rek.ur_title ? <h2>{rek.ur_title}</h2> : null}
          {this.renderRequisites(rek)}

          <ul className="ng-tare-sign__props">
            <li>Оборотная тара: <strong>{act.tare_count} шт.</strong></li>
            {act.masked_phone ? <li>Телефон: {act.masked_phone}</li> : null}
          </ul>

          <ul className="ng-tare-sign__terms">
            {(act.terms_lines || []).map((line, i) => <li key={i}>{line}</li>)}
          </ul>
        </section>

        {this.state.notice ? <div className="order-message">{this.state.notice}</div> : null}
        {this.state.error ? <div className="order-message">{this.state.error}</div> : null}

        {codeRequired ? (
          <section className="ng-checkout__section">
            <label>Код из SMS</label>
            <input
              className="input__text"
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={4}
              placeholder="4 цифры"
              value={this.state.code}
              onChange={this.setCode}
            />
            <div className="ng-tare-sign__hint">
              Отправили код на {act.masked_phone}.{' '}
              <a href="#" onClick={(e) => { e.preventDefault(); this.resend(); }}>
                {isBusy(this, 'resend') ? 'Отправляем…' : 'Получить новый код'}
              </a>
            </div>
          </section>
        ) : (
          <p className="ng-tare-sign__hint">
            Нажимая «Подписываю», вы подтверждаете получение тары в аренду на условиях выше.
          </p>
        )}

        <div className="ng-cart-actions">
          <button
            type="submit"
            className="btn"
            disabled={isBusy(this, 'sign') || noAttempts || (codeRequired && this.state.code.length < 4)}
          >
            {isBusy(this, 'sign') ? 'Подписываем…' : (codeRequired ? 'Подписать' : 'Подписываю')}
          </button>

          {act.can_skip ? (
            <button
              type="button"
              className="btn btn--ghost"
              onClick={this.skip}
              disabled={isBusy(this, 'skip')}
            >
              Подпишу позже
            </button>
          ) : null}
        </div>
      </form>
    );
  }
}

export const TareSignForm = observer(TareSignFormView, ['orderStore', 'authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/Checkout/TareSignForm.jsx